module.exports = __webpack_public_path__ + "static/img/person_num.d4e3a846.png";